import { useState } from 'react';
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get, post } from "@utils/axios_api";
import { qk } from "@utils/queryKey";

const fetchStdtModalList = async (params) => {
  const response = await get("/admin/lectureStudent/lectureStdtModalList", { params });
  return response;
};

export function useLectureStdtModal(lectureId) {
  const queryClient = useQueryClient();
  const methods = useForm({
    defaultValues: {
      searchCnd: '',
      searchWrd: '',
      eduDtCd: '',
    },
    shouldFocusError: false, // Focus 방지
  });

  const [selectedItems, setSelectedItems] = useState([]);
  const [committedSearch, setCommittedSearch] = useState({
    searchCnd: "",
    searchWrd: "",
  });

  const [pageIndex, setPageIndex] = useState(1);
  const recordCountPerPage = 5;

  const { searchCnd, searchWrd } = committedSearch;

  const resetSearch = () => {
    if (!window.confirm('조회 조건을 초기화 하시겠습니까?')) return;
    setCommittedSearch({ searchCnd: "", searchWrd: "" });
    setPageIndex(1);
    setSelectedItems([]);
    methods.reset({ searchCnd: "", searchWrd: "", eduDtCd: "" });
  };


  const { data, refetch } = useQuery({
    queryKey: ["selectLectureStdtModalList", committedSearch, pageIndex, lectureId],
    queryFn: () =>
        fetchStdtModalList({ searchCnd, searchWrd, pageIndex, recordCountPerPage, lectureId }),
      keepPreviousData: true,
  });

  const onSubmit = (values) => {
    setCommittedSearch(values);
    setPageIndex(1);
    setSelectedItems([]);
  };

  const handlePageChange = (targetPage) => {
    setPageIndex(targetPage);
  };

  const handleSelectAll = (e) => {
    if (!data?.resultList) return;
    setSelectedItems(
      e.target.checked ? data.resultList.map((i) => i.memberId) : []
    );
  };

  const handleSelectItem = (id) =>
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
    );

  const isAllChecked = !!(data?.resultList?.length && selectedItems.length === data?.resultList?.length);
  const resetSelection = () => setSelectedItems([]);

  const addStudent = async (eduDtCd) => {
    const payload = {
        lectureId,
        memberIdList: selectedItems,
        eduDtCd: eduDtCd || 'F',
    };
    const response = await post("/admin/lectureStudent/addStudent", payload);
   
   /* 추가전 수강생 목록 새로고침 */ 
   await queryClient.invalidateQueries({
     predicate: (q) =>
       q.queryKey[0] === "selectLectureStdtModalList" &&
       q.queryKey.includes(lectureId),
   });

    queryClient.invalidateQueries({ queryKey: qk.lectureAdminRoot(lectureId) });

    /* 메인 수강생 목록 새로고침 */
    // queryClient.invalidateQueries({ queryKey: qk.studentList(lectureId) });
    // queryClient.invalidateQueries(["selectAdminLectureStudentList", lectureId]);

    /* 출석부 목록 새로고침 */
    // queryClient.invalidateQueries({ queryKey: qk.attendList(lectureId) });
    // queryClient.invalidateQueries(["selectAdminLectureAttend", lectureId]);

    return response;
  };

  return {
    methods, data, onSubmit, isAllChecked, selectedItems,
    handlePageChange, handleSelectAll, handleSelectItem, addStudent,
    pageIndex, recordCountPerPage,
    refetch, resetSelection, resetSearch
  };
}
